/**
 * Rechte-Arten
 */
export enum UserPermissionType {
   /**
    * Rechte für Modul Geburtstage
    */
   moduleBirthdays = "moduleBirthdays",

   /**
    * Rechte für Modul Gruppen
    */
   moduleGroups = "moduleGroups",

   /**
    * Rechte für Modul Ferienbetreuung
    */
   moduleHolidays = "moduleHolidays",

   /**
    * Rechte für Modul Mailings
    */
   moduleMailings = "moduleMailings",

   /**
    * Rechte für Modul Mitglieder
    */
   moduleMembers = "moduleMembers",

   /**
    * Rechte für Modul Zahlungsverkehr
    */
   modulePayments = "modulePayments",

   /**
    * Rechte für Modul Verleih
    */
   moduleRental = "moduleRental",

   /**
    * Rechte für Modul Statistiken
    */
   moduleStatistics = "moduleStatistics",

   /**
    * Rechte für Modul Kurse
    */
   moduleWorkshops = "moduleWorkshops",

   /**
    * Rechte für Modul Personen (Clients und Accounts)
    */
   moduleClients = "moduleClients",

   /**
    * Rechte für Modul Veranstaltungen
    */
   moduleEvents = "moduleEvents",

   /**
    * Rechte für Modul Accounts
    */
   moduleAccounts = "moduleAccounts",
}

export const UserPermissionTypeNames = {
   moduleBirthdays: "Modul: Geburtstage",
   moduleGroups: "Modul: Gruppen",
   moduleHolidays: "Modul: Ferienbetreuung",
   moduleMailings: "Modul: Mailings",
   moduleMembers: "Modul: Mitglieder",
   modulePayments: "Modul: Zahlungsverkehr",
   moduleRental: "Modul: Verleih",
   moduleStatistics: "Modul: Statistiken",
   moduleWorkshops: "Modul: Kurse",
   moduleClients: "Modul: Personen",
   moduleEvents: "Modul: Veranstaltungen",
   moduleAccounts: "Accounts"
};